import React from "react";
import "./PersonLink.scss";

// Context: docs/components/person-link.md (no-id fallback, what pins each behaviour)
const PersonLink: React.FunctionComponent<any> = ({ person }) => {
  if (!person || !person.name) return null;
  // ⚠️ No id means plain text, not a disabled link: live payloads lack `person.id`
  // until MW PR #731 is on QA, and the text node keeps the DOM identical to before.
  if (!person.id) return <React.Fragment>{person.name}</React.Fragment>;
  return (
    <a className="person-link" href={`/person/${person.id}`} target="_blank" rel="noopener noreferrer">
      {person.name}
      <span className="sr-only"> (opens in a new tab)</span>
    </a>
  );
};

export default PersonLink;
